export default "__VITE_ASSET__5I5Zs_k$__"